import React, {useEffect, useState} from "react";
import Pagination from "rc-pagination";
import { connect } from "react-redux";
import { Alert } from "reactstrap";


// components
import WishlistItemRow from "../../../components/wishlist/WishlistItemRow";

// labels
import { LB_EMPTY_TABLE, } from "../../../components/i18n/i18n";

// actions
import { setViewMode } from "../../../redux/actions/generalActions/mainActions";
import { setFilter, setTableParams } from "../../../redux/actions/generalActions/listActions";
import { setForm, setItem } from "../../../redux/actions/generalActions/formActions";
import { add } from "../../../redux/actions/todoFluye/wishlistActions";
import { search } from "../../../redux/actions/todoFluye/inHouseActions";
import ListHeader from "../../../components/wishlist/components/ListHeader";

const InHouseRequestList = props => {
    const udn = JSON.parse(localStorage.getItem('selectedUdn')) || null
    const { pageSize, pageIndex, totalSize, listDomainObjects:components, filter, currentPage } = props.listState

    const [modal, setModal] = useState(false);
    const [, setWishlist] = useState(false);


    useEffect( () => {
        if(!filter || filter?.searchType == 'WISHLIST')
            props.setFilter({
                udn:{ id : udn?.id },
                searchType: 'REQUEST'
            })
    },[])

    useEffect(()=> {
        if(!filter  || filter?.searchType == 'WISHLIST')
            return

        refreshDataList()
    },[filter, pageIndex, pageSize])

    const refreshDataList = () => props.search(pageIndex, pageSize, currentPage, filter)

    const handleToggleModal = (_wishlist, _component) => {
        props.setItem(_component);
        setWishlist(_wishlist);
        setModal(!modal);
    }

    const onPageChange = page => {
        let currentIndex = (page - 1) * pageSize
        props.setTableParams( pageSize, currentIndex, totalSize, page );
    }

    return <>

        <ListHeader type={'REQUEST'}/>

        {
            (!components || components.length == 0) ? <Alert color="warning"> <i className={'fa fa-exclamation-triangle'} aria-hidden="true" />{LB_EMPTY_TABLE} </Alert>
                : components.map( (component, i) => <WishlistItemRow
                    key={`wl-component-${i}`}
                    wishlist={ component?.wishlist }
                    component={ component }
                    showModal={_ => handleToggleModal(component?.wishlist, component) }
                />)
        }

        <div className={'mt-2em '}>
            <Pagination
                locale={'es_ES'}
                current={ currentPage }
                pageSize={pageSize}
                total={totalSize}
                onChange={onPageChange}
            />
        </div>
    </>
}

const mapStateToProps = state => ({
    mainState: state.mainProps,
    listState : state.listProps,
})

const mapActionsToProps = ({
    setFilter,
    search,
    add,
    setTableParams,
    setViewMode,
    setItem, setForm
})

export default connect(mapStateToProps, mapActionsToProps)(InHouseRequestList)